function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */


import PPX from '../../vendor/ppx';
import env from '../env';
import URI from 'urijs';
import Backbone from '@polleverywhere/backbone';
import $ from 'jquery';

var AuthToken = /*#__PURE__*/function () {
  function AuthToken(token) {
    this.token = token;
  }
  /*
   * Attempt to grab a token from www.polleverywhere.com through the PPX
   * iframe proxy and log in with it (through the Nginx proxy).
   */


  var _proto = AuthToken.prototype;

  _proto.authenticate = function authenticate() {
    var _this = this;

    var deferred = $.Deferred();
    this.getCachedOrNewToken().then(function (json) {
      _this.post(json).then(deferred.resolve, deferred.reject);
    }).fail(deferred.reject);
    return deferred.promise();
  };

  _proto.getCachedOrNewToken = function getCachedOrNewToken() {
    var deferred = $.Deferred();

    if (this.token != null) {
      deferred.resolve({
        token: this.token
      });
    } else {
      this.get().then(deferred.resolve, deferred.reject);
    }

    return deferred.promise();
  };

  _proto.logout = function logout() {
    /*
     * Why a GET for logout? We don't want to allow DELETE requests via this
     * proxy because DELETE requests are more risky.
     * We already allow logout via GET (www.polleverywhere.com/logout) so this
     * isn't an extra risk.
     */
    return this.get(this.logoutUrl);
  };

  _proto.ppxClient = function ppxClient() {
    if (this._ppxClient) {
      return this._ppxClient;
    }

    var ppxUrl = env.get('api_url').path('/ppx_proxy');
    this._ppxClient = PPX.buildClientConstructor(ppxUrl.toString());
    return this._ppxClient;
  };

  _proto.post = function post(tokenJson) {
    return Backbone.ajax({
      dataType: 'json',
      method: 'POST',
      url: this.url,
      data: tokenJson
    });
  };

  _proto.get = function get(url) {
    /*
     * This is using our PPX proxy, so we don't want any of our CSRF or Proxy
     * code being run.
     */
    if (!url) {
      url = this.url;
    }

    return $.ajax({
      dataType: 'json',
      url: URI(url).absoluteTo(env.get('api_url').toString()).toString(),
      xhr: this.ppxClient()
    });
  };

  _createClass(AuthToken, [{
    key: "url",
    get: function get() {
      return '/api/participant_auth_token';
    }
  }, {
    key: "logoutUrl",
    get: function get() {
      return '/api/participant_auth_token/logout';
    }
  }]);

  return AuthToken;
}();

export { AuthToken as default };